export const MEMBERSHIP_APPLICATION_URL = 'https://hi.fi/apply?typeform-welcome=0'
export const CONTACT_EMAIL = 'artistfinancialservices@tidal.com'
